// API client — Auth vendeur (Lot M1). Sessions cookie httpOnly.
const BASE = process.env.REACT_APP_BACKEND_URL || "";

async function req(path, opts = {}) {
  const { method = "GET", body } = opts;
  const res = await fetch(`${BASE}${path}`, {
    method,
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: body ? JSON.stringify(body) : undefined,
  });
  const text = await res.text();
  const data = text ? JSON.parse(text) : null;
  if (!res.ok) {
    const err = new Error(data?.detail || `HTTP ${res.status}`);
    err.status = res.status;
    throw err;
  }
  return data;
}

export const sellerAuthApi = {
  exchangeMagic: (token) => req(`/api/seller/magic/${token}`, { method: "POST" }),
  loginCode:     (reference, code) =>
    req("/api/seller/login-code", { method: "POST", body: { reference, code } }),
  me:            () => req("/api/seller/me"),
  logout:        () => req("/api/seller/logout", { method: "POST" }),
  myMandates:    () => req("/api/seller/mandates"),
  myMandate:     (id) => req(`/api/seller/mandates/${id}`),
};

export default sellerAuthApi;
